import { render, staticRenderFns } from "./ViewRecordList.vue?vue&type=template&id=ec18f510&"
import script from "./ViewRecordList.vue?vue&type=script&lang=js&"
export * from "./ViewRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports